import { Button, Icon } from '@pairy/pds-react';
import { useState } from 'react';

import ComponentToolTip from '../../../common/Tags/ComponentToolTip';

import OneToOneLinkGenerateModal from './OneToOneLinkGenerateModal';

interface Props {
  fileId: number;
}

const OneToOneLinkGenerateButton = ({ fileId }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <ComponentToolTip
        description={
          <>
            1:1 발송용 링크를 만들면 상대방이 이메일이나 다른 정보를 입력하지
            않아도
            <br />
            고객의 열람 여부를 파악할 수 있습니다.
          </>
        }
      >
        <Button
          variant="skyblue_400"
          radius={8}
          paddingX={16}
          paddingY={12}
          textVariant="md-medium"
          width="100%"
          leftIcon={<Icon icon="ph:user" size={17} color="inherit" />}
          onClick={() => setIsModalOpen(true)}
        >
          1:1 공유용 링크 생성하기
        </Button>
      </ComponentToolTip>
      <OneToOneLinkGenerateModal
        fileId={fileId}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </>
  );
};

export default OneToOneLinkGenerateButton;
